import ReactECharts from 'echarts-for-react';
import {useState, useEffect} from "react";
import '../../../../cssfiles/homepage.css';
import { Typography } from '@mui/material';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector, useDispatch } from "react-redux";
import { updatefilter } from '../../../../store/mainpage_data';

const DonutCategorywise = (props) => {
    const [data1, setData1] = useState([0,0,0])
    const [datachart, setDataChart]= useState([]);   
    const theme = useSelector((state) => state.themedata.theme)
    const newdata = useSelector((state) => state.mainpagedata.updateddashboarddata)
    //const filter = useSelector((state) => state.mainpagedata.filter)
    const dispatch = useDispatch();
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)

    const[option,setOption]= useState({});  
    
    useEffect(() => {
        const tag_properties = props.widgetprop.props.extended.tagprops;
        const color_map = new Map();
        const data = [];
        let sum = 0.0;
        var tagproperty 
        tag_properties.forEach(charttype => {
            tagproperty = charttype.calculation.calculation_operations_list.categories;
            for(let tagpropkey in tagproperty){
                color_map.set(tagpropkey, tagproperty[tagpropkey].chartprops.color);
                if (tagcollectionvalue.hasOwnProperty(tagpropkey)) {
                    let tagSum = 0.0;
                    tagSum = Number(tagcollectionvalue[tagpropkey])
                    data.push(Number.parseFloat(tagSum).toFixed(2));
                }
            }
            
            
        });

        const donutchartbasedoptions = {
            title: {
                text: "",
                subtext: "",
                top: '110px',
                left: "90px",
                paddingTop: "13px",
                textStyle: {
                    fontSize: props.widgetprop.props.extended.textname.fontsize,
                    fontWeight: props.widgetprop.props.extended.textname.fontweight,
                    fontFamily: props.widgetprop.props.extended.textname.fontfamily,
                    align: "center",
                    color: (theme === 'light') ? "#3C3C3C" : "#FFFFFF",
                },
                subtextStyle: {
                    fontSize: props.widgetprop.props.extended.textvalue.fontsize,
                    fontWeight: props.widgetprop.props.extended.textvalue.fontweight,
                    fontFamily: props.widgetprop.props.extended.textvalue.fontfamily,
                    color: (theme === 'light') ? "#3C3C3C" : "#FFFFFF",
                    align: "center",
                },
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['70%', '80%'],
                    itemStyle: {
                        borderColor: (theme === 'light') ? "#FFFFFF" : "#000000",
                        borderWidth: 3,
                    },
                    emphasis: {
                        scaleSize: 0
                    },
                    label: {
                        position: 'inside',
                        formatter: '{d}%',
                        color: (theme === 'light') ? "#000000" : "#FFFFFF",
                        fontSize: '10px',
                        fontWeight: 700,
                        fontFamily: "Roboto"
                    },
                    data: Object.keys(tagproperty).map((charttype, index) => (
                        { value: Number(data[index]), name: tagproperty[charttype].category_name, itemStyle: { color: color_map.get(tagproperty[charttype].category_name) }, label: { show: false } }
                    ))
                },
                {
                    name: '',
                    type: 'pie',
                    radius: [0, '70%'],
                    itemStyle: {
                        borderColor: (theme === 'light') ? "#FFFFFF" : "#000000",
                        borderWidth: 3,
                    },
                    emphasis: {
                        scaleSize: 0
                    },
                    label: {
                        position: 'inside',
                        formatter: '{c}',
                        color: "#FFFFFF"
                    },
                    data: Object.keys(tagproperty).map((charttype, index) => (
                        { value: Number(data[index]), name: tagproperty[charttype].category_name, itemStyle: { color: (theme === 'light') ? tagproperty[charttype].chartprops.color_inner_light : tagproperty[charttype].chartprops.color_inner_dark }, label: { show: true, color: (theme === 'light') ? "#000000" : "#FFFFFF" } }
                    ))
                },
            ],
            legend: {
                left: '250px',
                top: '40px',
                borderColor: 'var(--PrimaryBackground)',
                paddingTop: 20,
                paddingLeft: 10,
                paddingRight: 2,
                itemGap: 30,
                itemStyle: {
                    color: 'inherit',
                    borderColor: '',
                    borderWidth: 0
                },
                textStyle: {
                    color: (theme === 'light') ? '#000000' : '#FFFFFF'
                },
                data: Object.keys(tagproperty).map((charttype, index) => (
                    { value: data[index], name: tagproperty[charttype].category_name, itemStyle: { color: color_map.get(tagproperty[charttype].category_name) }, label: { show: false } }
                )).map((data_object) => (
                    { name: data_object.name, icon: 'circle' }
                )),
                z: 4,
                orient: 'vertical',
            },
            tooltip: {
                trigger: 'item',
                backgroundColor: '#005C8E',
                borderColor: '#000000',
                borderRadius: [0, 0, 0, 8],
                borderWidth: 0,
                renderMode: 'html',
                extraCssText: 'border-radius: 0 0 0 8px',
                textStyle: {
                    color: '#FFFFFF',
                    fontSize: 12,
                    height: 3,
                    fontFamily: "Roboto",
                    padding: 0
                },
                formatter: function (params) {
                    let stringconst;
                    Object.keys(tagproperty).map(charttype => {
                        if (params.data.name === tagproperty[charttype].category_name) {
                            stringconst = `<div style="display:flex; flex-direction:row "><div style="border-radius:10px; margin-top:4px; margin-right:5px; height:10px; width:10px; background-color:${color_map.get(tagproperty[charttype].category_name)}"></div>${params.data.name}:${params.data.value}</div>`;
                        }
                    });
                    return stringconst;
                }
            },
            grid: {
                left: -50,
                top: 30,
                containLabel: true
            },
            height: 250,
            width: 230
        };

        setOption(donutchartbasedoptions);
    }, [props.widgetprop, theme, tagcollectionvalue]);

    return(
        <>
            <div style={{display:'inline-flex', flexDirection:'row', width:"100%", height:"100%"}}>
                    <ReactECharts option={option} style={{ height: '95%', width: '140%', }} />
            </div>
        </>
    ); 
};

export default DonutCategorywise;